const channels = {
  getlist: 'AdsChannel/getlist',
  getAll: 'AdsChannel/getall',
  get: 'AdsChannel/get',
  add: 'AdsChannel/add',
  update: 'AdsChannel/update',
  remove: 'AdsChannel/remove'
}
export default channels
